// extracted by mini-css-extract-plugin
module.exports = {"inform":"inform--AS_cd","boxTitle":"boxTitle--2PR__","info":"info--mUINA","high":"high--2NZ9A","btns":"btns--Ab5Nj","yellowBtn":"yellowBtn--2iYqP","editor":"editor--35OVR"};